import { useState, useEffect } from "react";
import { FileProcessing } from "../../components/BulkActions/FileProcessing";
import { ValidateFile } from "../../components/BulkActions/ValidateFile";
import { InputLabel, MenuItem, Select, Typography , Checkbox} from "@mui/material";
import { useAuthMfaSecure } from "providers/AuthSecureManage/AuthMfaSecureManage";

export function UnifiedIssuing(): JSX.Element {
  const { listModules } = useAuthMfaSecure();
  
  const [startEmission, setStartEmission] = useState<boolean>(false);
  const [businessEventId, setBusinessEventId] = useState<number>();
  const [fileName, setFileName] = useState<string>();
  const [issuanceType, setIssuanceType] = useState<string>('');
  const [partnerName, setPartnerName] = useState<string>('');

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const modules = await listModules();
        if (modules && modules.length > 0 && modules[0].partner) {
          const pName = modules[0].partner.name.toLowerCase();
          setPartnerName(pName);
          
          // Set default issuance type based on partner
          if (pName === 'rappi') {
            setIssuanceType('certification');
          } else if (pName === 'zubale' || pName === 'scape') {
            setIssuanceType('common_invoices');
          }
        }
      } catch (error) {
        console.error("UnifiedIssuing: Error fetching modules", error);
      }
    };
    fetchModules();
  }, [listModules]);

  const isRappi = partnerName === 'rappi';
  const isZubale = partnerName === 'zubale';
  const isScape = partnerName === 'scape';

  const issuanceStatus = (id: number) => {
    setStartEmission(true);
    setBusinessEventId(id);
  };
  const getFileName = (name: string) => {
    setFileName(name);
  };

  return (
    <div style={{padding: '0rem 3rem 0rem 3rem'}}>
      <h1 style={{ fontSize: "1.5rem" }}>Emisiones masivas</h1>
      <div style={Styles.container}>
        <div style={{display: 'flex', flexDirection: 'row', gap: '1rem'}}>
          <Typography variant="h5" component="h2" style={{ fontSize: "1.1rem", display: "flex" }}>
            Selección de tipo de emision
          </Typography>
          <Select
              sx={{ height: "2.5rem", width: '20rem' }}
              name="select"
              label="Seleccionar un tipo de emision"
              value={issuanceType}
              onChange={(e) => setIssuanceType(e.target.value)}
            >
              {/* Rappi options */}
              {isRappi && [
                <MenuItem key="certification" value="certification">Certificación</MenuItem>,
                <MenuItem key="fc3" value="fc3">Factura de cuenta a terceros</MenuItem>
              ]}
              
              {/* Zubale options */}
              {isZubale && [
                <MenuItem key="certification" value="certification">Certificación</MenuItem>,
                <MenuItem key="common_invoices" value="common_invoices">Factura normal masiva</MenuItem>
              ]}
              
              {/* Scape options */}
              {isScape &&
                <MenuItem value="common_invoices">Factura normal masiva</MenuItem>
              }
            </Select>
        </div>
        
        {issuanceType  && (
          <>
            <ValidateFile issuanceStatus={issuanceStatus} getFileName={getFileName} typeEmission={issuanceType}/>
            <FileProcessing startEmission={startEmission} businessEventId={businessEventId} fileName={fileName}/>
          </>
        )}
      </div>
    </div>
  );
}

const Styles = {
  container: {
    backgroundColor: "#fff",
    padding: "1.5rem",
    marginTop: "1.5rem",
    borderRadius: "0.5rem",
    boxShadow: "0px 1px 2px 0px rgba(25, 57, 91, 0.30), 0px 1px 3px 1px rgba(25, 57, 91, 0.15)",
  }
};
